export default __webpack_public_path__ + "static/media/bostfactory-pattern.21819f4c.svg";